(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compatibilidade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('x-compat-list')) {
    customElements.define(
      'x-compat-list',
      class CompatList extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-compat-query]');
          this.rows = Array.from(this.querySelectorAll('[data-compat-row]'));
          this.empty = this.querySelector('[data-compat-empty]');
          if (!this.input) return;
          this.onInput = this.onInput.bind(this);
          this.input.addEventListener('input', this.onInput);
        }

        disconnectedCallback() {
          if (this.input) this.input.removeEventListener('input', this.onInput);
        }

        onInput() {
          const q = this.input.value.trim().toLowerCase();
          let shown = 0;
          this.rows.forEach((row) => {
            const hit = q === '' || (row.dataset.terms || '').indexOf(q) !== -1;
            row.hidden = !hit;
            if (hit) shown += 1;
          });
          if (this.empty) this.empty.hidden = shown !== 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
